module.exports = __webpack_public_path__ + "img/sports.89b496e8.png";